(() => {
  'use strict';
  const cache = new Map(), forms = new Map();
  const text = value => String(value || '').trim();
  const quote = value => text(value).replace(/["\\]/g, ' ');
  const root = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
  const safeLink = (value, kind) => {
    try {
      const url = new URL(value, location.origin);
      if (url.origin !== location.origin || !url.pathname.includes('/' + kind + '/')) return null;
      ['_pos', '_sid', '_ss', '_psq', '_psid', '_fid'].forEach(key => url.searchParams.delete(key));
      return url.pathname + url.search + url.hash;
    } catch { return null; }
  };
  const initialize = () => {
    document.querySelectorAll('[data-db-smart-search]').forEach(form => {
      if (forms.has(form)) return;
      const input = form.querySelector('input[type="search"]');
      const box = form.querySelector('[data-db-results]');
      const config = form.querySelector('[data-db-search-config]');
      if (!input || !box || !config) return;
      let labels;
      try { labels = JSON.parse(config.textContent); } catch { return; }
      const vendor = form.querySelector('[data-db-vendor]');
      const type = form.querySelector('[data-db-type]');
      const min = form.querySelector('[name="filter.v.price.gte"]');
      const max = form.querySelector('[name="filter.v.price.lte"]');
      const sort = form.querySelector('[name="sort_by"]');
      const clear = form.querySelector('[data-db-query-clear]');
      const filters = form.querySelector('.db36-search-filters');
      const compiled = document.createElement('input');
      compiled.type = 'hidden';
      compiled.name = 'q';
      input.name = 'q_text';
      form.appendChild(compiled);
      input.setAttribute('role', 'combobox');
      input.setAttribute('aria-autocomplete', 'list');
      input.setAttribute('aria-expanded', 'false');
      input.setAttribute('aria-controls', input.id + '-options');
      input.setAttribute('aria-haspopup', 'listbox');
      let timer, controller, serial = 0, selected = -1;
      const value = field => text(field?.value);
      const compile = () => [value(input), vendor?.value ? 'vendor:"' + quote(vendor.value) + '"' : '', type?.value ? 'product_type:"' + quote(type.value) + '"' : ''].filter(Boolean).join(' ') || '*';
      const resultUrl = () => {
        const url = new URL(form.action, location.origin);
        url.searchParams.set('q', compile());
        url.searchParams.set('type', 'product');
        url.searchParams.set('options[prefix]', 'last');
        url.searchParams.set('sort_by', sort?.value || 'relevance');
        const reversed = value(min) && value(max) && Number(max.value) < Number(min.value);
        if (value(min)) url.searchParams.set(min.name, reversed ? max.value : min.value);
        if (value(max)) url.searchParams.set(max.name, reversed ? min.value : max.value);
        return url.pathname + url.search;
      };
      const hide = () => {
        clearTimeout(timer);
        controller?.abort();
        ++serial;
        selected = -1;
        box.hidden = true;
        box.replaceChildren();
        box.removeAttribute('aria-busy');
        input.removeAttribute('aria-activedescendant');
        input.setAttribute('aria-expanded', 'false');
      };
      const syncClear = () => { if (clear) clear.hidden = !value(input); };
      const render = (data, failed = false) => {
        selected = -1;
        input.removeAttribute('aria-activedescendant');
        box.replaceChildren();
        box.removeAttribute('aria-busy');
        const products = (data?.resources?.results?.products || []).slice(0, 5);
        const collections = (data?.resources?.results?.collections || []).slice(0, 3);
        const head = document.createElement('p');
        head.className = 'db-v33-results__head';
        head.setAttribute('role', 'status');
        head.textContent = failed ? labels.error : products.length || collections.length ? labels.instant : labels.empty;
        box.appendChild(head);
        const list = document.createElement('div');
        list.id = input.id + '-options';
        list.className = 'db-v33-results__grid';
        list.setAttribute('role', 'listbox');
        list.setAttribute('aria-label', labels.instant);
        const addOption = (item, kind) => {
          const href = safeLink(item.url, kind);
          if (!href) return;
          const link = document.createElement('a');
          link.href = href;
          link.id = list.id + '-' + list.childElementCount;
          link.className = 'db-v33-results__item';
          link.setAttribute('role', 'option');
          link.setAttribute('aria-selected', 'false');
          link.tabIndex = -1;
          const source = typeof item.image === 'string' ? item.image : item.image?.url || item.featured_image?.url;
          if (source && kind === 'products') {
            try {
              const photo = new URL(source, location.origin);
              if (photo.protocol === 'https:' && (photo.origin === location.origin || photo.hostname === 'cdn.shopify.com' || photo.hostname.endsWith('.myshopify.com'))) {
                photo.searchParams.set('width', '112');
                const image = document.createElement('img');
                image.src = photo.href;
                image.width = image.height = 56;
                image.alt = '';
                image.loading = 'lazy';
                link.appendChild(image);
              }
            } catch {}
          }
          const copy = document.createElement('span');
          copy.className = 'db-v33-results__copy';
          const title = document.createElement('strong');
          title.textContent = item.title;
          const detail = document.createElement('small');
          detail.textContent = kind === 'collections' ? labels.collections : item.vendor || '';
          const amount = Number(item.price);
          if (item.price !== undefined && item.price !== null && item.price !== '' && Number.isFinite(amount)) detail.textContent += (detail.textContent ? ' · ' : '') + new Intl.NumberFormat(document.documentElement.lang || 'es', { style: 'currency', currency: form.dataset.currency || 'EUR' }).format(amount);
          copy.append(title, detail);
          link.appendChild(copy);
          list.appendChild(link);
        };
        products.forEach(item => addOption(item, 'products'));
        collections.forEach(item => addOption(item, 'collections'));
        box.appendChild(list);
        const all = document.createElement('a');
        all.className = 'db-v34-view-all';
        all.href = resultUrl();
        all.textContent = labels.all;
        box.appendChild(all);
        box.hidden = false;
        input.setAttribute('aria-expanded', 'true');
      };
      const predict = () => {
        clearTimeout(timer);
        controller?.abort();
        const request = ++serial;
        input.setCustomValidity('');
        syncClear();
        const term = value(input);
        if (term.length < 2) { hide(); return; }
        timer = setTimeout(async () => {
          if (cache.has(term)) { render(cache.get(term)); return; }
          controller = new AbortController();
          box.setAttribute('aria-busy', 'true');
          const url = new URL(root + 'search/suggest.json', location.origin);
          url.searchParams.set('q', term);
          url.searchParams.set('resources[type]', 'product,collection');
          url.searchParams.set('resources[limit]', '5');
          url.searchParams.set('resources[options][unavailable_products]', 'last');
          try {
            const response = await fetch(url, { signal: controller.signal, headers: { Accept: 'application/json' } });
            if (!response.ok) throw new Error('Search unavailable');
            const data = await response.json();
            if (request !== serial || !document.contains(form)) return;
            if (cache.size >= 20) cache.delete(cache.keys().next().value);
            cache.set(term, data);
            render(data);
          } catch (error) {
            if (error.name !== 'AbortError' && request === serial && document.contains(form)) render(null, true);
          }
        }, 180);
      };
      const params = new URLSearchParams(location.search);
      if (!form.hasAttribute('data-db-inline')) {
        const vendorMatch = input.value.match(/(?:^|\s)vendor:"([^"]*)"/i);
        const typeMatch = input.value.match(/(?:^|\s)product_type:"([^"]*)"/i);
        if (vendorMatch && vendor) vendor.value = vendorMatch[1];
        if (typeMatch && type) type.value = typeMatch[1];
        input.value = input.value.replace(/(?:^|\s)(?:vendor|product_type):"[^"]*"/ig, ' ').replace(/^\*$/, '').replace(/\s+/g, ' ').trim();
        if (min) min.value = params.get(min.name) || '';
        if (max) max.value = params.get(max.name) || '';
        if (sort && ['relevance', 'price-ascending', 'price-descending'].includes(params.get('sort_by'))) sort.value = params.get('sort_by');
        if (filters && [vendor, type, min, max].some(field => value(field))) filters.open = true;
      }
      input.addEventListener('input', predict);
      input.addEventListener('focus', () => { if (box.hidden && value(input).length >= 2) predict(); });
      clear?.addEventListener('click', () => { input.value = ''; input.setCustomValidity(''); syncClear(); hide(); input.focus(); });
      form.addEventListener('change', () => {
        input.setCustomValidity('');
        const link = box.querySelector('.db-v34-view-all');
        if (link) link.href = resultUrl();
      });
      form.addEventListener('submit', event => {
        if (!value(input) && ![vendor, type, min, max].some(field => value(field))) {
          event.preventDefault();
          input.setCustomValidity(labels.required);
          input.reportValidity();
          return;
        }
        input.setCustomValidity('');
        if (value(min) && value(max) && Number(max.value) < Number(min.value)) [min.value, max.value] = [max.value, min.value];
        compiled.value = compile();
      });
      form.addEventListener('reset', () => {
        hide();
        requestAnimationFrame(() => {
          [input, min, max, compiled, vendor, type].forEach(field => { if (field) field.value = ''; });
          if (sort) sort.value = 'relevance';
          input.setCustomValidity('');
          syncClear();
          input.focus();
        });
      });
      input.addEventListener('keydown', event => {
        if (box.hidden) return;
        if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); hide(); return; }
        const options = [...box.querySelectorAll('[role="option"]')];
        if (!options.length) return;
        if (event.key === 'Enter' && selected >= 0) { event.preventDefault(); location.assign(options[selected].href); return; }
        if (!['ArrowDown', 'ArrowUp'].includes(event.key)) return;
        event.preventDefault();
        selected = Math.max(0, Math.min(options.length - 1, selected + (event.key === 'ArrowDown' ? 1 : -1)));
        options.forEach((option, index) => option.setAttribute('aria-selected', String(index === selected)));
        input.setAttribute('aria-activedescendant', options[selected].id);
        options[selected].scrollIntoView({ block: 'nearest' });
      });
      syncClear();
      forms.set(form, { hide, predict, input });
    });
    for (const [form] of forms) if (!document.contains(form)) forms.delete(form);
  };
  document.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    if (target.closest('[data-tc-search-open], [data-ms-search-open]')) {
      const headerInput = document.querySelector('.db-search-inline input[type="search"]');
      forms.forEach((state, form) => {
        if (form.closest('[data-tc-search]') && text(headerInput?.value)) { state.input.value = headerInput.value; state.predict(); }
        else if (form.hasAttribute('data-db-inline')) state.hide();
      });
    }
    forms.forEach((state, form) => {
      if (!form.contains(target) && !target.closest('[data-tc-search-open], [data-ms-search-open]') || target.closest('[data-tc-search-close]')) state.hide();
    });
  });
  document.addEventListener('focusin', event => { forms.forEach((state, form) => { if (!form.contains(event.target)) state.hide(); }); });
  document.addEventListener('shopify:section:load', initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
